import { send, type StudentEditable, type StudentHubInvitations } from "./api.js";

/**
 * Browser contract for ordinary tutor student creation.
 *
 * Deliberately cannot express tutor, payer, school/form or secondary-recipient
 * administration. The Hub derives the tutor relationship from the authenticated
 * principal and rejects a forged assignment even if a caller bypasses this type.
 */
export type TutorPrivateStudentCreate = {
  fullName: string;
} & Partial<
  Pick<
    StudentEditable,
    | "parentName"
    | "parentEmail"
    | "parentPhone"
    | "studentEmail"
    | "instrument"
    | "isUnder18"
  >
>;

export interface StudentCreateResult {
  student: StudentEditable & { id: string };
  linkedAccounts: string[];
  hubAccess?: StudentHubInvitations;
}

export function createTutorPrivateStudent(
  student: TutorPrivateStudentCreate & { inviteToHub?: boolean },
): Promise<StudentCreateResult> {
  return send<StudentCreateResult>("POST", "/admin/students", student);
}
